import { OptionType, Select, SelectType } from '@/components/form/fields/Select/Select';
import { MultiSelectValue } from './ui/MultiSelectValue';
import { ClearIndicator } from './ui/ClearIndicator';
import { MultiSelectOption } from './ui/MultiSelectOption';

export type MultiSelectType = SelectType & {
  placeholderValue?: string;
  value?: OptionType[];
};

export const MultiSelect = ({ placeholderValue, ...props }: MultiSelectType) => {
  return (
    <Select
      isMulti
      closeMenuOnSelect={false}
      components={{
        MultiValue: (multiValueProps) => <MultiSelectValue {...multiValueProps} placeholderValue={placeholderValue} />,
        ClearIndicator,
        Option: MultiSelectOption,
      }}
      formatOptionLabel={null}
      {...props}
    />
  );
};
